import { trackBranchBannerClose } from "shared_critical/tracking/shared/special_events";

MOVE.Branch = (function (MOVE) {

  var pageType = MOVE_DATA.pageType;

  var init = function() {
    if (typeof(branch) === "object") {
      var options = {disable_entry_animation: true, disable_exit_animation: true};
      window.branch.init(MOVE_DATA.branch_key, options, function(err, data) {
        MOVE_DATA.branch_has_app = data.has_app;
        setupEventTracking();
        setupBranchViewData();
        listenForDtm();
      })
    }
  };

  //Data to send to branch on banner link click
  var setupBranchViewData = function () {
    const ldpPhoto = getLdpPhoto();
    window.branch.setBranchViewData({
      data: {
        "referrer_id": "int-dsp_smart-banner_" + pageType,
        "rdcUrl": branchDeeplink(),
        "sub1": $.cookie("__vst"),
        ldpPhoto,
      }
    });
  };

  var getLdpPhoto = function () {
    if (MOVE_DATA.propertyDetails && MOVE_DATA.propertyDetails.photos && MOVE_DATA.propertyDetails.photos[0].url) {
      return MOVE_DATA.propertyDetails.photos[0].url;
    }
  };

  var setupEventTracking = function () {
    trackPageViews();
    trackLogin();
  };

  var branchDeeplink = function() {
    if (pageType==="ldp" || pageType==="srp") {
      return (location.protocol + "//" + location.host + location.pathname);
    }
    else {
      return (location.protocol + "//" + location.host);
    }
  };

  //Tracking flags to send to branch for banner targeting
  var trackPageViews = function () {
    if (pageType === 'srp') {
      window.branch.track('srpView');
    }
    else if (pageType === 'ldp') {
      window.branch.track('ldpView');
    }
  };

  var trackLogin = function () {
    if ($.cookie('REMEMBER_ME')) {
      window.branch.track('loggedIn');
    }
  };

  var trackBannerClose = function() {
   MOVE_DATA.adobeDTM.linkName = 'email:branch:close';
   trackBranchBannerClose();
   window.branch.track('journeyClose');
  };

  var listenForDtm = function () {
   window.branch.addListener('didClickJourneyClose', trackBannerClose);
  };

  MOVE.Branch = {
   init: init,
  };

  return MOVE.Branch;

})(MOVE || {});



// WEBPACK FOOTER //
// ./shared_critical/branch.js